// src/cert/iso13485.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO13485 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO 13485 प्रमाणन</h1>
                <p>वैद्यकीय उपकरणे गुणवत्ता व्यवस्थापन प्रणाली</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>.. ISO 13485 ..</h2>
                    <p>
                        Safety and Quality are non-negotiable in the medical devices industry, that why we developed ISO 13485
                        Regulatory requirements are increasingly stringent throughout every step of a products life cycle, including service and delivery. Increasingly, organizations in the industry are expected to demonstrate their quality management processes and ensure best practice in everything they do.
                        This internationally agreed standard sets out the requirements for a quality management system specific to the medical devices industry.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>रुग्ण सुरक्षा सुनिश्चित</li>
                        <li>FDA, CE Marking अनुपालन</li>
                        <li>जागतिक बाजारात प्रवेश</li>
                        <li>उत्पादन दोष कमी</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO 13485 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 13485" />
                </section>
            </div>
        </div>
    );
};

export default ISO13485; // default export